import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { LoggedInUserInfo } from '../models/login';
import { RootScopeService } from './root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  public loginDeatils: LoggedInUserInfo = new LoggedInUserInfo();
  constructor(private logger: NGXLogger, private rootScope: RootScopeService) {

  }

  //level  TRACE = 0,DEBUG = 1,INFO = 2, LOG = 3, WARN = 4,ERROR = 5,FATAL = 6,OFF = 7
  /* istanbul ignore next */
  trace(message) {
    this.genSysDetails();
    this.logger.trace(message, this.loginDeatils);
  }

  debug(message) {
    this.genSysDetails();
    this.logger.debug(message, this.loginDeatils);
  }

  /* istanbul ignore next */
  info(message) {
    this.genSysDetails();
    this.logger.log(message, this.loginDeatils);
  }

  warn(message) {
    this.genSysDetails();
    this.logger.warn(message, this.loginDeatils);
  }

  error(message, server?) {
    this.genSysDetails();this.loginDeatils.message=message;
    this.loginDeatils.serverError = server ? true : false;
     /* istanbul ignore next */
    this.logger.error(message, this.loginDeatils);
  }

  log(message) {
    this.genSysDetails();
    this.loginDeatils.message=message;
    this.logger.log(message, this.loginDeatils);
  }

  /* istanbul ignore next */
  fatal(message) {
    this.genSysDetails();this.loginDeatils.message=message;
    this.logger.fatal(message, this.loginDeatils);
  }

  genSysDetails() {
    this.loginDeatils.sessionId=this.rootScope.sessionId;
    this.loginDeatils.userName = this.rootScope.name;
    this.loginDeatils.lanId = this.rootScope.lanId;
    //this.loginDeatils.token = this.rootScope.sessionId;
  }


}
